import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ItemsList } from "@parkschannel/ui";
import { ProductSection } from "./ProductSection";
import { ProductCarousel } from "../ProductCarousel";
export const ProductsList = (param)=>{
    let { data  } = param;
    return /*#__PURE__*/ _jsx(ItemsList, {
        className: "mt-8",
        liClassName: "mb-4",
        items: data.children,
        renderItem: (product)=>/*#__PURE__*/ _jsx(ProductSection, {
                data: product,
                children: /*#__PURE__*/ _jsx(ProductCarousel, {
                    productId: product.id
                })
            })
    });
};
